import { useLogin } from "@sveabank/cc-common";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { resetError, selectError } from "../../slices/errorSlice";
import { DefaultError } from "./default-error";
import { defaultErrorContent, errorCodeMap, statusCodeMap } from "./error-content";
import { RevisionConflict } from "./revision-conflict";

const ErrorModal = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { doLogout } = useLogin();
	const { errorMsg, statusCode, errorCode, correlationId } = useSelector(selectError);

	useEffect(() => {
		// todo: kan detta fortfarande ske?
		if (errorMsg && statusCode === 401 && !pathname.includes("login")) {
			doLogout();
		}
	}, [errorMsg, statusCode, navigate]);

	if (!errorMsg) return null;

	// oxlint-disable-next-line no-console
	console.error(new Error(errorMsg));

	const isOpen = !!errorMsg;

	const closeModal = () => {
		dispatch(resetError());
	};

	if (errorCode === "InvalidRevision")
		return <RevisionConflict open={isOpen} onClose={closeModal} />;

	const content =
		(errorCode && errorCodeMap[errorCode]) ||
		(statusCode && statusCodeMap[statusCode]) ||
		defaultErrorContent;

	return (
		<DefaultError
			message={errorMsg}
			body={content.body}
			heading={content.heading}
			correlationId={correlationId}
			open={isOpen}
			setOpen={(isOpen) => !isOpen && closeModal()}
		/>
	);
};

export default ErrorModal;
